import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { ApiUriContants } from '../_constants/apiUriConstants';
import { CacheService } from "./cache.service";

@Injectable({
    providedIn: "root"
})
export class TrackingServiceMapTiler {
    constructor(private httpService: HttpService, private cacheService: CacheService) { }
    KPIList(queryParams = {}) {
        const url = `${ApiUriContants.TrackingScreenMapTiler}getfleetview`;
        return this.httpService.post(url, queryParams);
    }
    getPassagesData(vesselId: any, startDate: any, endDate: any) {
        const url = `${ApiUriContants.TrackingScreenMapTiler}getpassagedata`;
        return this.httpService.get(url, { vesselId: vesselId, startDate: startDate, endDate: endDate });
    }
    getPassagesDataLatestReport(vesselId: any) {
        const url = `${ApiUriContants.TrackingScreen}getpassagedatalatestreport`;
        return this.httpService.get(url, { vesselId: vesselId });
    }
    getVessleAlertData() {
        const url = `${ApiUriContants.TrackingScreenMapTiler}getvesselalerts`;
        return this.httpService.get(url);
    }

    GetPassageDataForChart(data: any) {
        const url = `${ApiUriContants.TrackingScreenMapTiler}getpassagedataforchart`;
        return this.httpService.post(url, data);
    }

    // Latest Poition to be displayed on map
    Getvesselpositions(data: any) {
        const url = `${ApiUriContants.voyages}getvesselpositions`;
        return this.httpService.post(url, data);
    }

    getVesselLatestPositions(id: any, vesselIds: any = null) {
        const url = `${ApiUriContants.voyages}getvessellatestpositions`;
        return this.httpService.post(url, { groupId: id, vesselIds });
    }

    getVesselLatestPositionsTrackScreen(id: any, vesselIds: any = null) {
        const url = `${ApiUriContants.TrackingScreenMapTiler}getvessellatestpos`;
        return this.httpService.post(url, { vesselGroupIds: id, vesselIds });
    }
    // Close

    getecadata(params: any) {
        const url = `${ApiUriContants.voyages}getecadata`;
        return this.httpService.get(url, params);
    }
    deleteMeteoStratumData(params: any) {
        const url = `${ApiUriContants.voyages}deletemeteostratumdata`;
        return this.httpService.delete(url, params);
    }
    getMarineWeatherImage(params: any) {
        const url = `${ApiUriContants.voyages}getmarineweatherimage`;
        return this.httpService.get(url, params);
    }

    getMyVessels() {
        const url = `${ApiUriContants.TrackingScreen}getMyVessels`;
        return this.httpService.get(url);
    }

    KPIListByVessel(queryParams = {}) {
        const url = `${ApiUriContants.TrackingScreen}getfleetviewbyvessel`;
        return this.httpService.get(url, queryParams);
    }
    getPassageSummary(vesselId: any) {
        const url = `${ApiUriContants.TrackingScreen}getpassagesummary`;
        return this.httpService.get(url, { vesselId: vesselId });
    }
    async getvesselcount(loginUserId: any) {
        const cachedData = this.cacheService.getNestedValue("cacheObj", `userMappedVesselGroupList.${loginUserId.loginUserId}`);
        if (cachedData) {
            return cachedData;
        }
        const url = `${ApiUriContants.TrackingScreenMapTiler}getallvesselgroupcount`;
        const data = await this.httpService.get(url, loginUserId);
        this.cacheService.setNestedValue("cacheObj", `userMappedVesselGroupList.${loginUserId.loginUserId}`, data);
        return data;
    }

    getProgressMetrics(vesselId: any) {
        const url = `${ApiUriContants.TrackingScreen}getProgressMetrics`;
        return this.httpService.get(url, { vesselId: vesselId });
    }
    getVesselDataByImo(imonumber: number) {
        const url = `${ApiUriContants.TrackingScreenMapTiler}getvesseldatabyimonumber`;
        return this.httpService.post(url, imonumber); 
    }
    getPortList(){
        const url = `${ApiUriContants.TrackingScreenMapTiler}getallports`;
        return this.httpService.post(url);
 
    }

    getAnalyticsData(payload: { imoNumber: string; actualStartOfSeaPassage: string, startTimeZone: string }) {
    const url = `${ApiUriContants.TrackingScreenMapTiler}getanalyticsdata`;
    return this.httpService.post(url, payload);
    }

}
